import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const FilledTextFieldElement = withStyles({
  root: {
    background: '#f9f9f9',
    margin: '0.5rem auto',
    '&.MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#e6e6e6',
      },
      '&:hover fieldset': {
        borderColor: '#0094f6',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#0094f6',
      },
    },
    '&.MuiOutlinedInput-adornedStart': {
      padding: 0,
      '& .MuiInputAdornment-root': {
        background: '#ffffff',
        maxHeight: '100%',
        height: '56px',
        padding: '0 1rem',
        borderRight: '1px solid #e6e6e6',
        '& p': {
          'margin-block-start': 0,
          'margin-block-end': 0,
        },
      },
    },
  },
})(OutlinedInput);

const FilledTextField = (props) => {
  const attributes = { ...props };

  return (
    <FilledTextFieldElement fullWidth {...attributes}>
      {props.children}
    </FilledTextFieldElement>
  );
};

export default FilledTextField;
